import { render, staticRenderFns } from "./aceitos.vue?vue&type=template&id=bde86e72&"
import script from "./aceitos.vue?vue&type=script&lang=js&"
export * from "./aceitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports